import { call, put, select } from 'redux-saga/effects';
import { push } from 'store/navigation/actions';
import { logoutFailure, logoutSuccess, setThirdPartySSO } from '../actions';
import { logout } from '../api';
import routes from 'routes';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnMessageOn } from 'store/app/actions';
import { resetAccountData } from 'store/account/actions';
import { resetOrganisationData } from 'store/organisation/actions';
import { resetReturnData } from 'store/returns/actions';
import { resetUserData } from 'store/user/actions';
import { resetVatData } from 'store/vat/actions';
import { resetVatCheckerData } from 'store/vat-checker/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { handleExtensionCalls } from 'utils/handleExtensionCalls';
import { getThirdPartySSO } from '../selectors';
import { clearGenTaxCalledPage } from 'utils/check-page-loaded';
import { clearPwaLastEntity } from 'utils/pwa-last-entity';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* logoutSaga() {
  try {
    clearGenTaxCalledPage();
    clearPwaLastEntity();
    const thirdPartySSO = yield select(getThirdPartySSO);

    yield put(push(routes.login));
    yield call(logout);

    yield put(resetAccountData());
    yield put(resetOrganisationData());
    yield put(resetReturnData());
    yield put(resetUserData());
    yield put(resetVatData());
    yield put(resetVatCheckerData());
    yield put(logoutSuccess());
    handleExtensionCalls('reloadPopup').then((res) => {
      console.log(res.message);
    });
    if (thirdPartySSO) {
      yield put(setThirdPartySSO(thirdPartySSO));
    }
    //localStorage.setItem('loggedOut', 'true');
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    }
    yield put(logoutFailure());
  }
}
